var map = {
	"./app.svg": 84568,
	"./bar.svg": 61954,
	"./calendar.svg": 47025,
	"./cancel.svg": 76757,
	"./check-small.svg": 13611,
	"./check.svg": 7289,
	"./clock.svg": 46003,
	"./close.svg": 83125,
	"./copy-icon.svg": 95074,
	"./deal-canceled.svg": 52395,
	"./deal-completed.svg": 11685,
	"./deal-dispute.svg": 12238,
	"./deal-in.svg": 15175,
	"./deal-out.svg": 31794,
	"./delete.svg": 41066,
	"./details.svg": 50667,
	"./device-offline.svg": 68427,
	"./device-online.svg": 46495,
	"./dropdown.svg": 31724,
	"./instruction.svg": 16137,
	"./loader.svg": 88722,
	"./menu/dashboard.svg": 85751,
	"./menu/deals.svg": 10390,
	"./menu/disputes.svg": 21874,
	"./menu/logout.svg": 24175,
	"./menu/requisites.svg": 92983,
	"./menu/settings.svg": 34794,
	"./menu/statistic.svg": 25721,
	"./menu/traderOperators.svg": 74516,
	"./paperclip.svg": 30529,
	"./pause.svg": 59043,
	"./save.svg": 45916,
	"./tg.svg": 33344,
	"./usdt.svg": 22847,
	"./warning.svg": 49049,
	"./xmark.svg": 18482
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68525;